import React, { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { LessButton, MoreButton } from './StepButton';

const NumberInputWithStepButtons = ({
    value,
    setValue,
    min,
    max,
    readonly,
    classNames: { container, textInput, button, buttonContent },
    ...props
}) => {
    const inputEl = useRef(null);
    useEffect(() => {
        let v = value;

        inputEl.current.value = v;
    }, [inputEl, value]);

    const onChangeInput = e => {
        let v = e.target.value;

        if (parseInt(v, 10)) {
            setValue(v);
        }
    };
    const buttonProps = {
        value,
        setValue,
        classNames: {
            button,
            buttonContent,
        },
    };
    return (
        <div className={container} {...props}>
            {!readonly && <LessButton {...buttonProps} /> }
            <input
                data-quantity-text="data-quantity-text"
                type="number"
                min={min}
                max={max}
                ref={inputEl}
                readOnly={readonly}
                onChange={onChangeInput}
                className={textInput}
            />
            {!readonly && <MoreButton {...buttonProps} /> }
        </div>
    );
};

NumberInputWithStepButtons.propTypes = {
    value: PropTypes.number.isRequired,
    setValue: PropTypes.func.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    readonly: PropTypes.bool,
    classNames: PropTypes.shape({
        container: PropTypes.string,
        textInput: PropTypes.string,
        button: PropTypes.string,
        buttonContent: PropTypes.string,
    }),
};

NumberInputWithStepButtons.defaultProps = {
    min: 0,
    max: undefined,
    readonly: false,
    classNames: {
        container: 'm2g-number-input',
        textInput: 'm2g-number-input-text-input',
        button: 'm2g-number-input-button',
        buttonContent: 'm2g-number-input-button-content',
    },
};

export default memo(NumberInputWithStepButtons);
